import { render } from "./Content.vue?vue&type=template&id=072bc0c1&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=072bc0c1&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-072bc0c1"

export default script